import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MaterialesService } from './../../../services/API/materiales/materiales.service';
import { XlsxService } from './../shared/xlsx/xlsx.service';
import { ConfirmDialogComponent } from './../shared/components/confirm-dialog/confirm-dialog.component';
import { NewMaterialComponent } from './components/new-material/new-material.component';
import { EditMaterialComponent } from './components/edit-material/edit-material.component';
import { NotificationServiceService } from './../../../services/notification-service/notification-service.service';
import { AuthService } from './../../../services/API/auth/auth.service';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
    selector: 'app-materiales',
    templateUrl: './materiales.component.html',
    styleUrls: ['./materiales.component.css'],
    standalone: false
})
export class MaterialesComponent implements OnInit {

  showProgressBar: boolean = true;
  displayedColumns = ['id', 'nombre', 'descripcion', 'tipo', 'activo'];
  dataSource1: any = [];
  pages = [20, 50, 100];
  filter:string;
  dataSource = new MatTableDataSource(this.dataSource1);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  tipo: string = 'all';
  active: string = 'true';

  constructor(private dialog: MatDialog, public authService: AuthService, private xlsxService: XlsxService, private materialesService: MaterialesService, private notificationService: NotificationServiceService) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_total');
    this.getMateriales();
  }

  userRolCheck(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }
  
  getMateriales() {
    this.showProgressBar = true;
    this.materialesService.getMateriales(this.tipo, this.active).subscribe(result => {
      this.showProgressBar = false;
      this.dataSource1 = result;
      this.prepareTable();
    });
  }

  newMaterial(){
    const dialog = this.dialog.open(NewMaterialComponent, {
      width: '90%',
      maxWidth: '500px'
    });
    dialog.afterClosed().subscribe(result => {
      if(result){
        this.showProgressBar = true;
        this.materialesService.newMaterial(result["nombre"], result["descripcion"], result["tipo"], result["activo"].toString()).subscribe(() => {
          this.notificationService.openSnackBar("Material creado correctamente!");
          this.showProgressBar = false;
          this.getMateriales();
        });
      }
    });
  }

  editarMaterial(id: number) {
    for (var i = 0; i < this.dataSource1.length; i++) {
      if(this.dataSource1[i]["id"] === id){
        const modifDialog = this.dialog.open(EditMaterialComponent, {
          data: {'nombre': this.dataSource1[i]["nombre"], 'descripcion' : this.dataSource1[i]["descripcion"], 'tipo' : this.dataSource1[i]["tipo"], 'activo' : this.dataSource1[i]["activo"]},
          width: '90%',
          maxWidth: '500px'
        });
        modifDialog.afterClosed().subscribe(result => {
          if(result){
            this.showProgressBar = true;
            console.log(result["activo"]);
            this.materialesService.editMaterial(id, result["nombre"], result["descripcion"], result["tipo"], result["activo"].toString()).subscribe(() => {
              this.notificationService.openSnackBar("Material modificado correctamente!");
              this.showProgressBar = false;
              this.getMateriales();
            });
          }
        });
        break;
      }
    }
  }

  deleteMaterial(id: number) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar material', body: '¿Seguro que deseas eliminar este material?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.materialesService.deleteMaterial(id).subscribe(() => {
          this.notificationService.openSnackBar("¡Material eliminado correctamente!");
          this.showProgressBar = false;
          this.getMateriales();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.dataSource1);
    this.paginator._intl.itemsPerPageLabel = 'Materiales por página:';
    this.filter = '';
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveExcel() {
    const data = this.dataSource.data;
    const excelData = data.map(item => ({
      'Nombre': item['nombre'],
      'Descripción': item['descripcion'],
      'Tipo': item['tipo'],
      'Estado': item['activo'],
    }));
    this.xlsxService.saveExcelData(excelData, 'Residuos');
  }

}
